import { afterEvent, cardRef, defineGameCard } from '../authoring/index.js';
import { adultTreeDeathLeaf, freeOwnCells, growthOf, isLiveOnBoard, PLANT_GROWTH_ID, photosynthesis, removeGrowth, tableOf, } from './plant-helpers.js';
/**
 * Великий баньян — взрослая форма Побега баньяна. За каждые 2 Роста создаёт
 * Лист в случайной свободной своей ячейке локации и получает Щит 1. Если
 * места для Листа нет, вместо него получает Щит 2. При Гибели оставляет Лист в ячейке.
 */
export const GreatBanyanCard = defineGameCard({
    id: 'great_banyan',
    gameplay: {
        type: 'UNIT',
        cost: 4,
        baseStats: { attack: 8, health: 10 },
        traits: ['PLANT', 'TREE'],
    },
    presentation: {
        name: 'Великий баньян',
        description: 'За каждые 2 Роста тратит их, создаёт Лист в случайной свободной вашей ячейке этой локации и получает Щит 1. Если места для Листа нет, вместо него получает Щит 2. Гибель: создайте Лист в этой ячейке.',
        glyph: {
            colors: ['#10213A', '#3A6037', '#24432B', '#172620', '#9A6C35'],
            rows: [
                '.......111111.......',
                '.....1122222211.....',
                '...1122222222221....',
                '..1222222222222311..',
                '.122222222222222221.',
                '12222222222222232331',
                '12222232333222333331',
                '12323233333333333331',
                '13344342344434334444',
                '.3434444443443443444',
                '.3.4444434223444444.',
                '.3..44443553444.23..',
                '....33.155531.2.33..',
                '....33.155531.2..3..',
                '.....3.155531.......',
                '.......155531.......',
                '.....115555311......',
                '...1155353553311....',
                '..15511131153111....',
                '...11..5...115......',
            ],
        },
    },
    role: 'auxiliary',
    abilities: [
        ...photosynthesis(),
        afterEvent({
            event: 'EffectCounterChanged',
            run: {
                source: 'card_effect',
                dependencies: [cardRef(PLANT_GROWTH_ID), cardRef('plant_leaf')],
                run: (ctx, ...args) => {
                    const event = args[0];
                    const self = ctx.self;
                    if (!isLiveOnBoard(self)
                        || event.defId !== PLANT_GROWTH_ID
                        || event.key !== 'growth'
                        || event.scope.kind !== 'unit'
                        || event.scope.instanceId !== self.id)
                        return;
                    const freeCells = freeOwnCells(ctx, self.controllerId, tableOf(self.cellId));
                    const pairs = Math.floor(growthOf(ctx, self.id) / 2);
                    if (pairs <= 0)
                        return;
                    const leafCount = Math.min(pairs, freeCells.length);
                    const fallbackShieldCount = pairs - leafCount;
                    const destinations = ctx.rng.shuffle(freeCells).slice(0, leafCount);
                    removeGrowth(ctx, self.id, pairs * 2, 'banyan');
                    for (const cellId of destinations) {
                        ctx.ops.tryCreateToken('plant_leaf', self.controllerId, cellId);
                        ctx.ops.addShield(GreatBanyanCard.id, self.id, 1, self.id);
                    }
                    for (let index = 0; index < fallbackShieldCount; index += 1) {
                        ctx.ops.addShield(GreatBanyanCard.id, self.id, 2, self.id);
                    }
                },
            },
        }),
        adultTreeDeathLeaf(),
    ],
    ui: { mechanics: ['growth', 'photosynthesis', 'shield', 'token', 'death'] },
});
//# sourceMappingURL=great_banyan.js.map